module.exports = __webpack_public_path__ + "assets/img/842e-er.svg";